export const LocalStorageKeys = {
  AUTH_TOKEN: 'access-token',
};
